import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Table, Button, Flex, Popconfirm } from 'antd';

import { TableCol } from './getTableCol';

import { courseStruct } from './struct';
import { getRandomId } from '../../../../../../utilities/randomId';
import { getAsNumber } from '../../../../../../utilities/numberConvertion';

export const Supervision = ({ courses, semesterName, updateSemester }) => {
    const { table, actionSection } = courseStruct;

    const _static = useSelector((state) => state.static);
    const { staticData } = _static;

    const { supervision_course: supervisionCourse } = staticData;
    const defaultCourse = supervisionCourse && supervisionCourse.length ? supervisionCourse[0] : {};
    const { value } = defaultCourse;

    const [_courses, setCourses] = useState(courses && courses.length ? courses : []);

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        setCourses(courses && courses.length ? courses : []);
    }, [courses]);

    const handleAdd = () => {
        const newPlaning = { key: getRandomId(), name: value, no_student: 0 };
        const updated = [..._courses, newPlaning];
        setCourses(updated);
        updateSemester(semesterName, updated);
    };

    const handleSave = (row) => {
        const currentCourses = [..._courses];
        const index = currentCourses.findIndex((item) => row.key === item.key);
        const item = currentCourses[index];

        row.no_student = getAsNumber(row.no_student);

        currentCourses.splice(index, 1, { ...item, ...row });
        setCourses(currentCourses);
        updateSemester(semesterName, currentCourses);
    };

    const handleDelete = (key) => {
        const newData = _courses.filter((item) => item.key !== key);
        setCourses(newData);
        updateSemester(semesterName, newData);
    };

    // ❌ DELETE — do not add this back:
    // useEffect(() => {
    //     updateSemester(semesterName, _courses);
    // }, [_courses, semesterName]);

    const columns = [
        ...TableCol(handleSave),
        {
            title: 'Action',
            dataIndex: 'operation',
            render: (_, record) => {
                const { key } = record;
                return (
                    <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(key)}>
                        <a>Delete</a>
                    </Popconfirm>
                );
            }
        }
    ];

    return courses ? (
        <>
            <Table {...table} columns={columns} dataSource={_courses} />
            <br />
            <Flex {...actionSection}>
                <Button className="glow-btn" onClick={handleAdd}>Add New Item</Button>{' '}
            </Flex>
        </>
    ) : (
        <></>
    );
};